import Axios from 'axios'
import * as API from '@/endpoints'
import Cons from '@/constants.json'
import router from '@/router'
import VueCookie from 'vue-cookie'

let axiosHttpReq = Axios.create({
  headers: {}
});

export default {
  namespaced: true,
  state: {
    guestWho: {}
  },
  mutations: {
    setGuestData (state, payload) {
      state.guestWho = payload
    }
  },
  actions: {
    async registerGuest (context) { 
      context.commit('base/setUserAuthLoader', true, {root:1});
      context.commit("base/setLoadingPage", true, {root:1});
      delete axiosHttpReq.defaults.headers.common['Authorization']
      return await axiosHttpReq.post(`${API.endpoints.base}/user/guest`, {
          client_id: "HqrmdSC4PXaeHjuN",
          slug: router.history.current.params.brandSlug
      }).then( res => {
        context.commit('base/setUserAuth', res.data, {root:1})
        context.dispatch("base/refreshToken", {
            refreshToken: res.data.refresh_token
        }, {root: 1})
      })
    }
  }
}
